import { LESSON_TYPE_LABELS } from './lesson-types';
import type { LessonType } from '@/types';

type AddLessonInlineProps = {
  title: string;
  setTitle: (v: string) => void;
  lessonType: LessonType;
  setLessonType: (v: LessonType) => void;
  isPending: boolean;
  error: string | null;
  onSubmit: () => void;
  onCancel: () => void;
};

export function AddLessonInline({
  title,
  setTitle,
  lessonType,
  setLessonType,
  isPending,
  error,
  onSubmit,
  onCancel,
}: AddLessonInlineProps) {
  return (
    <div className="space-y-2 px-4 py-2.5 pl-12">
      <div className="flex items-center gap-2">
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && onSubmit()}
          placeholder="Título de la lección"
          className="flex-1 rounded border border-input bg-background px-2 py-1 text-sm"
          autoFocus
        />
        <select
          value={lessonType}
          onChange={(e) => setLessonType(e.target.value as LessonType)}
          className="rounded border border-input bg-background px-2 py-1 text-xs"
        >
          {Object.entries(LESSON_TYPE_LABELS).map(([k, v]) => (
            <option key={k} value={k}>
              {v}
            </option>
          ))}
        </select>
        <button
          onClick={onSubmit}
          disabled={isPending}
          className="text-xs font-medium text-primary"
        >
          Agregar
        </button>
        <button onClick={onCancel} className="text-xs text-muted-foreground">
          Cancelar
        </button>
      </div>
      {error && <p className="text-xs text-destructive">{error}</p>}
    </div>
  );
}
